export default __webpack_public_path__ + "static/media/password_img.cdfb21c1.png";